import {useQuery} from '@tanstack/react-query'

import {getSuccessLogs, getErrorLogs, getSuccessLogsByCompany, getErrorLogsByCompany} from './api'
import {logKeys} from './keys'
import {SuccessLogResponse, ErrorLogResponse} from './types'

/**
 * Success logs (all)
 */
export const useSuccessLogs = () => {
  return useQuery<SuccessLogResponse[], unknown>({
    queryKey: logKeys.success(),
    queryFn: getSuccessLogs,
  })
}

/**
 * Error logs (all)
 */
export const useErrorLogs = () => {
  return useQuery<ErrorLogResponse[], unknown>({
    queryKey: logKeys.error(),
    queryFn: getErrorLogs,
  })
}

/**
 * Success logs by company
 */
export const useSuccessLogsByCompany = (companyId?: string) => {
  return useQuery<SuccessLogResponse[], unknown>({
    queryKey: companyId ? logKeys.successByCompany(companyId) : logKeys.success(),
    queryFn: () => {
      if (!companyId) {
        return Promise.resolve([])
      }
      return getSuccessLogsByCompany(companyId)
    },
    enabled: !!companyId,
  })
}

/**
 * Error logs by company
 */
export const useErrorLogsByCompany = (companyId?: string) => {
  return useQuery<ErrorLogResponse[], unknown>({
    queryKey: companyId ? logKeys.errorByCompany(companyId) : logKeys.error(),
    queryFn: () => {
      if (!companyId) {
        return Promise.resolve([])
      }
      return getErrorLogsByCompany(companyId)
    },
    enabled: !!companyId,
  })
}
